import { render } from "./index.vue?vue&type=template&id=c6a6363a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c6a6363a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c6a6363a"

export default script